export const QUICKSEARCH_SOURCE = {
  FM: 'FM',
  FM_DIR: 'FM_DIR'
}
